import { cn } from "@/lib/utils";
import { createLink, LinkComponent } from "@vixi/router";
import { ComponentProps, forwardRef } from "react";

export interface UnstyledAnchorProps extends ComponentProps<"a"> {
  disabled?: boolean;
}

export const UnstyledAnchor = forwardRef<HTMLAnchorElement, UnstyledAnchorProps>(
  ({ className, disabled, ...props }, ref) => (
    <a
      ref={ref}
      className={cn(
        "font-family-inherit box-border block cursor-pointer bg-none",
        disabled && "pointer-events-none",
        className,
      )}
      {...props}
    />
  ),
);

const CreatedLink = createLink(UnstyledAnchor);

export const UnstyledLink: LinkComponent<typeof UnstyledAnchor> = (props) => {
  return <CreatedLink {...props} />;
};

export type UnstyledLinkProps = ComponentProps<typeof UnstyledLink>;
